import {initContract} from '@ts-rest/core';
import {DB_SCHEMAS} from '../db/schemaExports';
import {z} from 'zod';
import {paginationQuerySchema, paginatedResponseSchema} from '../utils/pagination';

const c = initContract();

const userWithRoles = DB_SCHEMAS.selectUser.extend({
  roles: z.array(DB_SCHEMAS.selectRole)
});

export const usersContract = c.router(
  {
    get: {
      method: 'GET',
      path: '/:id',
      pathParams: z.object({
        id: z.string()
      }),
      responses: {
        200: userWithRoles,
        403: z.object({message: z.string()}),
        404: z.object({message: z.string()})
      },
      summary: 'Get a user'
    },
    update: {
      method: 'PUT',
      path: '/:id',
      pathParams: z.object({
        id: z.string()
      }),
      body: DB_SCHEMAS.updateUser,
      responses: {
        200: z.array(userWithRoles),
        403: z.object({message: z.string()}),
        404: z.object({message: z.string()})
      },
      summary: 'Update a user'
    },
    delete: {
      method: 'DELETE',
      path: '/:id',
      pathParams: z.object({
        id: z.string()
      }),
      responses: {
        200: z.array(userWithRoles),
        403: z.object({message: z.string()})
      },
      summary: 'Delete a user'
    },
    list: {
      method: 'GET',
      path: '/',
      query: z
        .object({
          email: z.string().email().optional(),
          tenantId: z.string().optional()
        })
        .merge(paginationQuerySchema)
        .extend({
          sortBy: z.enum(['email', 'fullName', 'createdAt']).optional()
        }),
      responses: {
        200: paginatedResponseSchema(userWithRoles),
        403: z.object({message: z.string()})
      },
      summary: 'List users (optionally filtered by email or tenant)'
    },
    me: {
      method: 'GET',
      path: '/me',
      responses: {
        200: userWithRoles
      },
      summary: 'Get the current authenticated user'
    }
  },
  {
    pathPrefix: '/users'
  }
);
